/* eslint-disable @typescript-eslint/no-var-requires */
import React, { ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Image from '@sport1/react-elements/Image'
import Touchable from '@sport1/react-elements/Touchable'
import { spacings } from '../../../DesignSystem/spacings'
import { LogoTypes } from '../LogoInterfaces'
import { Spacing } from '../../../Layouts/LayoutTypes'
import { spaceMapToPixel } from '../../../Layouts/LayoutUtils'
import { TestID } from '../../../utils/PropTypesDefinitions'
import LinkProps from '../../../Link/LinkProps'

export type LogoProps = {
    type?: LogoTypes
    onPress?: () => void
    href?: string
    width: number
    spaceX?: Spacing
} & LinkProps &
    TestID

const ON_LIGHT = require('../../../assets/logos/Sport1/OnLight.svg')
const ON_DARK = require('../../../assets/logos/Sport1/OnDark.svg')

const Sport1Logo = ({
    type = 'OnLight',
    width,
    onPress,
    href,
    spaceX,
    testID,
    webRel,
}: LogoProps): ReactElement => {
    const imageUrl = type === 'OnLight' ? ON_LIGHT : ON_DARK
    const aspect = 51 / 200
    const height = width * aspect
    return (
        <Grid
            horizontal
            noExpand
            paddingX={spaceX ? spaceMapToPixel.get(spaceX) : spacings['spacing-none']}
            testID={testID}
        >
            <Touchable disableHover onPress={onPress} href={href} webRel={webRel}>
                <Image src={imageUrl} width={width} height={height} />
            </Touchable>
        </Grid>
    )
}

export default memo(Sport1Logo)
